import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent
} from '@mui/material';
import SlidePicker from '../../pptxFiles/SlidePicker';

interface ChangeTemplateDialogProps {
  open: boolean;
  onClose: () => void;
  onPick: (slideNumber: number) => void;
  pptxFileId: string;
  lang: string;
}

function ChangeTemplateDialog({ open, onClose, onPick, pptxFileId, lang }: ChangeTemplateDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>
        {lang === 'en' ? 'Choose Template' : '选择模板'}
      </DialogTitle>
      <DialogContent>
        <SlidePicker 
          pptxFileId={pptxFileId} 
          onPick={(slideNumber) => {
            onPick(slideNumber);
            onClose();
          }} 
        />
      </DialogContent>
    </Dialog>
  );
}

export default ChangeTemplateDialog; 